import React from 'react'

import Checkbox from '@material-ui/core/Checkbox'
import CircularProgress from '@material-ui/core/CircularProgress'
import IconButton from '@material-ui/core/IconButton'
import Radio from '@material-ui/core/Radio'
import { withStyles } from '@material-ui/core/styles'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { SELECTOR_TYPE_CARET, SELECTOR_TYPE_CHECKBOX, SELECTOR_TYPE_RADIO } from 'drawer/tabs/layers/Layers'
import IsMapZoomedToLayerMinZoom from 'drawer/tabs/layers/utils/IsMapZoomedToLayerMinZoom'

const styles = theme => ({
  root: { },
  checkbox: {
    padding: '4px 6px 4px 10px' // Hack to make it look like the layertree
  },
  chevron: {
    paddingLeft: 8
  },
  progress: {
    margin: 8,
    marginRight: 14
  }
})

class LayerHeaderCheckbox extends React.Component {
  constructor (props) {
    super(props)
    const { classes } = this.props
    this.pure = {}
    this.pure.CircularProgress = <CircularProgress className={classes.progress} size={20} />
  }

  render () {
    const { classes, titleid, layerSelected, selectorType, loadstatus, mapZ, minZoom, toggleLayer } = this.props
    // console.debug('Render layer', titleid, 'header checkbox', layerSelected)

    const bEnabled = IsMapZoomedToLayerMinZoom(mapZ, minZoom)

    if (selectorType === SELECTOR_TYPE_RADIO) {
      return (
        <Radio
          aria-label={titleid}
          checked={layerSelected}
          color="default"
          name={titleid}
          onClick={toggleLayer}
          size="small"
          value={titleid}
        />
      )
    } else if (selectorType === SELECTOR_TYPE_CARET) {
      return (
        <IconButton aria-label="clear search" onClick={toggleLayer} className={classes.chevron}>
          { layerSelected ? <ExpandMoreIcon /> : <ChevronRightIcon /> }
        </IconButton>
      )
    } else if (selectorType === SELECTOR_TYPE_CHECKBOX) {
      return (
        <Checkbox className={classes.checkbox} size="small" disabled={!bEnabled} color="default" checked={layerSelected} onChange={toggleLayer} value={titleid} />
      )
    } else {
      // Hmmm.. what could it be.
      return null
    }
  }
}

LayerHeaderCheckbox.propTypes = {
  classes: PropTypes.object.isRequired,
  titleid: PropTypes.string.isRequired,
  layerSelected: PropTypes.bool.isRequired,
  selectorType: PropTypes.string.isRequired,
  loadstatus: PropTypes.string.isRequired,
  mapZ: PropTypes.number.isRequired,
  minZoom: PropTypes.number.isRequired,
  toggleLayer: PropTypes.func.isRequired
}

function mapStateToProps (state, ownProps) {
  const loadstatus = state.layers[ownProps.titleid].loadstatus
  const layerSelected = state.layers[ownProps.titleid].selected
  const selectorType = state.layers[ownProps.titleid].selectorType
  const minZoom = state.layers[ownProps.titleid].minZoom
  const mapZ = state.mapZ
  return {
    loadstatus,
    layerSelected,
    selectorType,
    minZoom,
    mapZ
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(LayerHeaderCheckbox)
  )
)
